import React, { useEffect, useState } from "react";
import Icon from "@mdi/react";
import { mdiWhatsapp } from "@mdi/js";
import Header from "./Header";
import Footer from "./Footer";
import { useSite } from "../theme/ThemeProvider";

function CookieNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try {
      setShow(
        !localStorage.getItem("mu:cookies") &&
          !sessionStorage.getItem("mu:cookies"),
      );
    } catch {
      setShow(false);
    }
  }, []);
  if (!show) return null;
  return (
    <div className="cookie" role="dialog" aria-label="Çerez bildirimi">
      <p>Bu site deneyiminizi iyileştirmek için çerezler kullanır.</p>
      <div className="cookie__actions">
        <button
          className="btn btn--primary btn--sm"
          onClick={() => {
            localStorage.setItem("mu:cookies", "1");
            setShow(false);
          }}
        >
          Kabul et
        </button>
        <button
          className="btn btn--ghost btn--sm"
          onClick={() => {
            sessionStorage.setItem("mu:cookies", "0");
            setShow(false);
          }}
        >
          Reddet
        </button>
      </div>
    </div>
  );
}

const Layout = ({ children }) => {
  const site = useSite();
  const embedded = typeof window !== "undefined" && window.parent !== window; // admin önizlemesi
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      {!embedded && (
        <a
          className="wa-float"
          href={`https://wa.me/${site.whatsapp}`}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp ile yazın"
        >
          <Icon path={mdiWhatsapp} />
        </a>
      )}
      {!embedded && <CookieNotice />}
    </>
  );
};

export default Layout;
